import { render, staticRenderFns } from "./iristarAbout.vue?vue&type=template&id=0d3bfe70&"
import script from "./iristarAbout.vue?vue&type=script&lang=js&"
export * from "./iristarAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports